export default [
  {
    path: '/conciliacoes',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'Conciliação Histórico',
        path: 'historico',
        component: () => import('@/views/conciliacoesV3/Historico.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [{ name: 'Power Ups', path: '/powerups' }, { name: 'Conciliação' }]
        }
      },
      {
        name: 'Conciliação Adicionar',
        path: 'edit',
        component: () => import('@/views/conciliacoesV3/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Conciliação', path: '/conciliacoes/historico' },
            { name: 'Nova' }
          ]
        }
      },
      {
        name: 'Conciliação Editar',
        path: 'edit/:id',
        component: () => import('@/views/conciliacoesV3/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Conciliação', path: '/conciliacoes/historico' },
            { name: 'Editar' }
          ]
        }
      }
    ]
  }
];
